import { gql } from '@apollo/client'

const TASK_FIELDS = gql`
  fragment TaskFields on TaskType {
    id
    createdAt
    title
    type
    time
    description
    link
    subject {
      id
      slug
      tabName
    }
  }
`

const SCHEDULER_FIELDS = gql`
  ${TASK_FIELDS}
  fragment SchedulerFields on SchedulerType {
    id
    phase1TaskIds
    phase2TaskIds
    phase3TaskIds
    phase1Title
    phase2Title
    phase3Title
    task {
      ...TaskFields
    }
  }
`

export const FIND_ALL_FOR_CMS_TASK = gql`
  ${TASK_FIELDS}

  query findAllForCMSTask($query: TaskQueryInput! = {}) {
    findAllForCMSTask(query: $query) {
      count
      items {
        ...TaskFields
      }
    }
  }
`

export const FIND_ALL_DELETED_TASK = gql`
  ${TASK_FIELDS}

  query findAllDeletedTask($query: TaskQueryInput! = {}) {
    findAllDeletedTask(query: $query) {
      count
      items {
        ...TaskFields
      }
    }
  }
`

export const FIND_ONE_TASK = gql`
  ${TASK_FIELDS}

  query findOneTask($id: String!) {
    findOneTask(id: $id) {
      ...TaskFields
    }
  }
`

export const CREATE_TASK = gql`
  mutation createTask($createTaskInput: CreateTaskInput!) {
    createTask(createTaskInput: $createTaskInput) {
      id
    }
  }
`

export const UPDATE_TASK = gql`
  mutation updateTask($updateTaskInputFieldName: UpdateTaskInput!) {
    updateTask(updateTaskInputFieldName: $updateTaskInputFieldName) {
      id
    }
  }
`

export const SOFT_REMOVE_TASK = gql`
  mutation softRemoveTask($softRemoveTaskId: LinkTaskInput!) {
    softRemoveTask(id: $softRemoveTaskId) {
      affected
    }
  }
`

export const BULK_SOFT_REMOVE_TASK = gql`
  mutation bulkSoftRemoveTasks($ids: [LinkTaskInput!]!) {
    bulkSoftRemoveTasks(ids: $ids) {
      affected
    }
  }
`

export const REMOVE_TASK = gql`
  mutation removeTask($removeTaskId: String!) {
    removeTask(id: $removeTaskId) {
      affected
    }
  }
`

export const BULK_REMOVE_TASK = gql`
  mutation bulkRemoveTask($ids: [LinkTaskInput!]!) {
    bulkRemoveTask(ids: $ids) {
      affected
    }
  }
`

export const RESTORE_TASK = gql`
  mutation restoreTask($id: LinkTaskInput!) {
    restoreTask(id: $id) {
      affected
    }
  }
`

export const BULK_RESTORE_TASK = gql`
  mutation bulkRestoreTask($ids: [LinkTaskInput!]!) {
    bulkRestoreTask(linkTaskInput: $ids) {
      affected
    }
  }
`

export const FIND_SCHEDULER = gql`
  ${SCHEDULER_FIELDS}

  query findOneScheduler($platformId: String!) {
    findOneScheduler(platformId: $platformId) {
      ...SchedulerFields
    }
  }
`

export const UPDATE_SCHEDULER = gql`
  mutation updateScheduler($scheduler: UpdateSchedulerInput!) {
    updateScheduler(updateSchedulerInputFieldName: $scheduler) {
      id
    }
  }
`

export const FIND_SCHEDULE_ANALYTICS = gql`
  query findScheduleAnalytics($platformId: String!) {
    findScheduleAnalytics(platformId: $platformId) {
      subjectChart {
        pieChartMetricName
        pieChartMetricValue
      }
      typeChart {
        pieChartMetricName
        pieChartMetricValue
      }
    }
  }
`
